import Type from './Type';
export function isIAudio(node) {
    return node.type === Type.Audio;
}
export default isIAudio;    //# sourceMappingURL=isIAudio.js.map
